const swiper = new Swiper(".timeline", {
  direction: "vertical",
  pagination: {
    el: ".swiper-pagination",
    type: "progressbar",
  },
  autoplay: {
    enabled: true,
    disableOnInteraction: true,
    delay: 300,
    waitForTransition: true,
  },
  navigation: {
    nextEl: ".button-next",
    prevEl: ".button-prev",
  },
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
  allowTouchMove: false,
  keyboard: {
    enabled: false,
  },
  loop: true,
  mousewheel: false,
  simulateTouch: false,
  a11y: {
    enabled: true,
  },
});

function play() {
  if (document.querySelector(".information-page")) return;
  swiper.autoplay.start();
  document.querySelector(".button-pause").classList.remove("hidden");
  document.querySelector(".button-autoplay").classList.add("hidden");
}

function pause() {
  if (document.querySelector(".information-page")) return;
  swiper.autoplay.stop();
  document.querySelector(".button-pause").classList.add("hidden");
  document.querySelector(".button-autoplay").classList.remove("hidden");
}

function status() {
  if (document.querySelector(".information-page")) return;
  if (swiper.autoplay.running === false) {
    document.querySelector(".button-pause").classList.add("hidden");
    document.querySelector(".button-autoplay").classList.remove("hidden");
  } else {
    document.querySelector(".button-pause").classList.remove("hidden");
    document.querySelector(".button-autoplay").classList.add("hidden");
  }
}

function handelEventListerners() {
  if (document.querySelector(".information-page")) return;
  document.querySelector(".button-pause").addEventListener("click", pause);
  document.querySelector(".button-autoplay").addEventListener("click", play);

  document.querySelector(".button-next").addEventListener("click", pause);
  document.querySelector(".button-prev").addEventListener("click", pause);
}

handelEventListerners();
// swiper.on('slideChange', status);
swiper.on("click", status);

const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

// Check if the media query matches or is not available.
if (mediaQuery.matches) {
  swiper.autoplay.stop();
}

mediaQuery.addEventListener("change", () => {
  console.log(mediaQuery.media, mediaQuery.matches);
  // Stop JavaScript-based animations.
  swiper.autoplay.stop();
});

const swiperHorizontal = new Swiper(".information", {
  direction: "horizontal",
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  hashNavigation: {
    replaceState: true,
  },
  autoplay: false,
  allowTouchMove: false,
  keyboard: {
    enabled: true,
  },
  loop: true,
  mousewheel: false,
  simulateTouch: false,
  snapOnRelease: true,
  a11y: {
    enabled: true,
  },
  navigation: {
    nextEl: ".button-next",
    prevEl: ".button-prev",
  },
});
